const chargers_config = () => [
  { name: 'Power type', dataKey: 'power_type' },
  { name: 'Power', dataKey: (e: any) => `${e.power} kW` },
  {
    name: `Time to charge`,
    dataKey: (e: any) => `${e.time_to_charge} minutes`,
  },
  {
    name: 'Estimated cost per charge point',
    dataKey: 'estimated_cost',
  },
]
const vehicle_config = () => [
  { name: 'Make', dataKey: 'make' },
  { name: 'Model', dataKey: 'model' },
  { name: 'GVM', dataKey: 'gvm' },
  { name: 'Payload', dataKey: 'payload' },
  { name: 'Battery capacity', dataKey: 'battery_capacity' },
  { name: 'Range up to', dataKey: 'range_up_to' },
]

export { chargers_config, vehicle_config }
